module.exports = __webpack_public_path__ + "static/media/qr-code-icon.3905af48.svg";